// MIGRATION: This is a temporary service to send broadcast messages from Angular in the AngularJS app
angular.
module("dx.webapp.angular").
factory("dxAJSBroadcastService", function broadcastService(
	$rootScope
) {
	"use strict";

	function sendNotification(type, message) {
		$rootScope.$broadcast("notification:" + type, message);
	}

	function send(type, message) {
		message ? $rootScope.$broadcast(type, message) : $rootScope.$broadcast(type);
	}

	return {
		sendNotification: sendNotification,
		send: send,
	};
});
